import request from "../request";
import { REACT_BASE_URL_GAMA_AUTH, REACT_BASE_URL_GAMA_USERS } from "../url";

export const authUserRequest = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_AUTH}/auth`,
    method: "POST",
    data,
  });
};

export const getUserProfileRequest = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/auth/profile`,
    method: "GET",
  });
};

export const attachAccessRequest = async ({ customerId }) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_AUTH}/auth/attach`,
    method: "POST",
    data: {
      customerId: customerId,
    },
  });
};

export const setClientHash = async ({ rut, password }) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_AUTH}/auth/remember`,
    method: "POST",
    data: {
      rut,
      password,
    },
  });
};

export const decodeClientHash = async ({ hash }) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_AUTH}/auth/decode`,
    method: "POST",
    data: {
      hash,
    },
  });
};

export const refreshTokenAuth = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_AUTH}/auth/refresh`,
    method: "POST",
  });
};

export const isValidAuthToken = async (token) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_AUTH}/auth/verify`,
    method: "POST",
    data: {
      token,
    },
  });
};
